import { IdealConditions } from './IdealConditions';

export default IdealConditions;
